<template>
  <div>
    <div v-if="modalShow">
      <img :src="wechatData.src" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
      <span>{{wechatData.value}}</span>
    </div>







    <div v-if="!modalIf && !modalShow" style="cursor: pointer" @click="mouseroverIf">
      <img :src="changeImg" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
      <span>{{wechatData.value}}</span>
    </div>

    <div v-if="modalIf">
      <Poptip v-model="modalIf" style="cursor:pointer;" placement="right" transfer width=148 trigger="click">

        <!-- 修改微信状态 -->
          <div>
            <img :src="changeImg" alt="" style="height:18px;margin-right:4px;vertical-align: middle;">
            <span>{{wechatData.value}}</span>
          </div>
          <div slot="content">

            <!-- 二维码 -->
            <vueQrcode v-if="wechatData.value !== '二维码'" slot="content" :value="wechatData.codeUrl" size="110"></vueQrcode>
            <div v-else style="cursor:pointer" @click="openWechatImg(wechatData.codeUrl)">
              <img v-if="wechatData.codeUrl" :src="wechatData.codeUrl" style="width:100%;height:100%;">
            </div>

            <!-- 微信状态修改 -->
            <div style="display: flex;justify-content:center;align-items: center;flex-wrap: wrap;padding:0px 8px 0 5px;">
              <Button typeof="ghost" size="small" style="display:block;margin-top:6px;flex:100%;" @click="changeWechat(1)">
                <img src="https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/wechat_online_access.png" alt=""
                     style="height:18px;margin-right:4px;vertical-align: middle">
                已添加
              </Button>
              <Button typeof="ghost" size="small" style="display:block;margin-top:6px;flex:100%;" @click="changeWechat(2)">
                <img src="https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/wechat_offline.png" alt=""
                     style="height:18px;margin-right:4px;vertical-align: middle">
                没加上
              </Button>
            </div>
          </div>

      </Poptip>
    </div>

  </div>
</template>

<script>
  import {dataDst,FGetCookie} from '../../common/util'

  export default {
    name: "render-wechat",
    props: {
      wechat: {
        type: Object,
      },
      encryption: {
        type: Boolean,
      }
    },
    data() {
      return {
        modalShow: false,
        modalIf:false,
        wechatText: '',
        imgss: '',
        changeImg: '',
        colsePoptip: '关闭',
        wechatImg: {
          '0': 'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/wechat_online.png',
          '1': 'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/wechat_online_access.png',
          '2': 'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/wechat_offline.png',
        }
      }
    },
    computed: {
      wechatData() {
        let codeUrl = ''
        let value = ''
        let src = this.wechatImg[this.wechat.row['weflag']]
        if (this.encryption) {
          this.modalShow = true
          value = dataDst(this.wechat.row.kzwechat)
        } else {
          this.modalIf = false
          value = this.wechat.row.kzwechat
          this.changeImg = src
          if(value === '二维码'){
            codeUrl = this.wechat.row.talkimg
          }else{
            codeUrl = `http://qrcode.qiein.com/index.html?phone=${this.wechat.row.kzwechat}&company_id=${FGetCookie('cid')}&kzid=${this.wechat.row.kzid}&staffid=${FGetCookie('uid')}`
          }
        }
        return {value, src, kzid: this.wechat.row.kzid, codeUrl}
      }
    },
    methods: {
      //修改微信
      changeWechat(status) {
        this.$http.post('client/edit_wc', {
          kzId: this.wechatData.kzid,
          weFlag: status
        }).then(data => {
          if (data.code === 100000) {
            this.colsePoptip = '关闭'
            this.$Message.success(data.msg)
            this.changeImg = this.wechatImg[status]
          } else {
            this.$Message.error(data.msg)
          }
        })
      },

      //手动加载 Poptip
      mouseroverIf(){
        this.modalIf = true
      },

      //放大图片
      openWechatImg(weImg){
        document.getElementById('modalImgUrl').src = weImg
        document.getElementById('modalImg').style.display = 'block'
        document.getElementById('modalImg').onclick = () => {
          document.getElementById('modalImgUrl').src = ''
          document.getElementById('modalImg').style.display = 'none'
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render-components/render-wechat.vue